(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("KarcherAlarmsViewModel", karcherAlarmsViewModelFactory);

  /** @ngInject */
  function karcherAlarmsViewModelFactory(
    gridUtils,
    DateTime,
    facilityUtils,
    $translate
  ) {
    function KarcherAlarmsViewModel() {
      this.paginationNumber = 0;
      this.activeAlarmsList = [];
      this.alarmsFrom = null;
      this.alarmsTo = null;
      this.siteList = [];
      this.selectedSite = "";
      this.filterBy = "";
      this.faultStatus = "";
      this.hideUnnecessary = true;
      this.placeHolderText = $translate.instant("SITE_NAME");
      this.noDataToDisplay = false;
      this.faultStatusList = [
        {
          name: "ALL",
          value: ""
        },
        {
          name: "INFO",
          value: "INFO"
        },
        {
          name: "WARNING",
          value: "WARNING"
        },
        {
          name: "ALARM",
          value: "ALARM"
        }
      ];

      // GRID CONFIG
      this.alarmsData = [];
      this.alarmsOrderBy = "timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [5, 10, 15];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.alarmsFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.alarmsTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );

      init.call(this);
    }

    KarcherAlarmsViewModel.prototype.destroy = function () {};

    KarcherAlarmsViewModel.prototype.alarmsPaginationChanged = function (
      page,
      limit
    ) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
    };

    KarcherAlarmsViewModel.prototype.alarmsOrderingChanged = function (order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    KarcherAlarmsViewModel.prototype.refreshMessages = function (data) {
      this.noDataToDisplay = data.content.length === 0;
      if (data.content.length === 0) {
        this.hideUnnecessary = false;
        this.alarmsData = [];
        this.alarmsData.push({
          timestamp: $translate.instant("NOTHING_TO_DISPLAY")
        });
      } else {
        this.hideUnnecessary = true;
        this.alarmsData = this.setStateIcon(data.content);
      }
      this.alarmsTotal = data.totalElements;
    };

    KarcherAlarmsViewModel.prototype.refreshSiteList = function (data) {
      this.siteList = data;
    };

    KarcherAlarmsViewModel.prototype.setStateIcon = function (data) {
      data.forEach(function (item) {
        switch (item.karcherFault.washFacilityStatus) {
          case "INFO":
            item.icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            item.icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            item.icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            item.icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      });
      return data;
    };

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return KarcherAlarmsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.pagerLabel = gridSettings.translations;
    }
  }
})();
